import React from 'react';

import './index.css';
import {Modal} from 'antd';
import type {QuestionWithNewFields} from '../Questions/QuestionTypes';
import {getFileUrlByKey} from '../../utils';

type modalPropsType = {
  question: QuestionWithNewFields;
  closeModal: () => void;
};

type ModalState = {
  authenticatedUrl: string | undefined;
  isLoading: boolean;
  error: string | null;
};

export class QuestionModal extends React.Component<modalPropsType, ModalState> {
  constructor(props: any) {
    super(props);
    this.state = {
      authenticatedUrl: undefined,
      isLoading: true,
      error: null,
    };
  }

  async componentDidMount() {
    await this.fetchAuthenticatedUrl();
  }

  fetchAuthenticatedUrl = async () => {
    const mediaItem = this.getMediaItem();
    console.log('Media item:', mediaItem);
    if (mediaItem?.url) {
      try {
        const pathContent = mediaItem.url.split('/');
        const bucketName = pathContent[3];
        const pathParts = mediaItem.url.split('.pikado.io/');
        console.log('Path parts:', pathParts);
        console.log('Bucket name:', bucketName);
        if (pathParts.length > 1) {
          const result = await getFileUrlByKey(pathParts[1], bucketName);
          const authenticatedUrl = result.url.toJSON();
          console.log('Authenticated URL:', authenticatedUrl);
          this.setState({authenticatedUrl, isLoading: false, error: null});
        } else {
          console.error('Could not extract path from URL');
          this.setState({isLoading: false, error: 'Invalid media URL format'});
        }
      } catch (error: any) {
        console.error('Error fetching authenticated URL:', error);
        let errorMessage = 'Failed to load media';

        // Check for specific error types
        if (
          error?.name === 'NotFound' ||
          error?.message?.includes('NotFound')
        ) {
          errorMessage = 'Media file not found';
        } else if (error?.name === 'NoCredentials') {
          errorMessage = 'Authentication error';
        } else if (error?.message) {
          // Use the error message if available for better debugging
          console.error('Detailed error:', error.message);
        }

        this.setState({isLoading: false, error: errorMessage});
      }
    } else {
      this.setState({isLoading: false, error: 'No media available'});
    }
  };

  getMediaItem = () => {
    const {question} = this.props;
    const payload =
      typeof question?.payload === 'string'
        ? JSON.parse(question.payload)
        : question?.payload;
    return payload?.media?.[0];
  };

  renderPhoto = () => {
    const {authenticatedUrl} = this.state;
    return (
      <img
        src={authenticatedUrl}
        alt="Question media"
        style={{
          maxWidth: '100%',
          maxHeight: '70vh',
          display: 'block',
          margin: '0 auto',
        }}
      />
    );
  };

  renderVideo = () => {
    const {authenticatedUrl} = this.state;
    return (
      <video
        controls
        style={{
          maxWidth: '100%',
          maxHeight: '70vh',
          display: 'block',
          margin: '0 auto',
        }}
        src={authenticatedUrl}
      />
    );
  };

  renderQuestion = () => {
    const {authenticatedUrl, isLoading, error} = this.state;
    const mediaItem = this.getMediaItem();

    if (!mediaItem) {
      return <div>No media available</div>;
    }

    if (isLoading) {
      return <div>Loading...</div>;
    }

    if (error) {
      return <div>{error}</div>;
    }

    if (!authenticatedUrl) {
      return <div>Loading...</div>;
    }

    switch (mediaItem.type) {
      case 'PHOTO':
        return this.renderPhoto();
      case 'VIDEO':
        return this.renderVideo();
      default:
        return <div>Unsupported media type</div>;
    }
  };

  render() {
    const {closeModal, question} = this.props;
    return (
      <Modal
        closable={false}
        className={'exercise-modal'}
        style={{maxHeight: '100%'}}
        width={'50%'}
        centered={true}
        onCancel={closeModal}
        open={true}
        onOk={() => {}}
        footer={<></>}>
        <div style={{width: '100%', textAlign: 'center'}}>
          {this.renderQuestion()}
        </div>
      </Modal>
    );
  }
}
